import { SelectedEngraveOptions } from '_app/types/product'

export const getEngravingOptions = (
  selectedEngraveOptions: SelectedEngraveOptions
) => {
  return Object.values(selectedEngraveOptions)
    .flatMap(pendant => [...(pendant?.front || []), ...(pendant?.back || [])])
    .filter(Boolean)
}
